/** Refresh everything that shows shortlist membership / totals. */
export function invalidateShortlistData(qc, shortlistId) {
  qc.invalidateQueries({ queryKey: ['shortlists'] });
  if (shortlistId) qc.invalidateQueries({ queryKey: ['shortlist', String(shortlistId)] });
  qc.invalidateQueries({ queryKey: ['item'] });
  qc.invalidateQueries({ queryKey: ['items'] });
}
